import AxiosClient from '../../../../functional/Axios/AxiosClient';

export const widgetsApi = {
  getWidgets: () => AxiosClient.get('/widgets'),
};
